'use client';
import { PlasmicCanvasContext } from "@plasmicapp/loader-nextjs";
import { useContext } from "react";
import { useUser } from "~/hooks/useUser";

interface LoginConditionWrapperProps {
  requiredCondition?: 'loggedin' | 'loggedout';
  children?: React.ReactNode;

  /**
  * FOR USE IN PLASMIC STUDIO ONLY
  */
  loggedInPreview: boolean;
}

export function LoginConditionWrapper({
  requiredCondition = 'loggedin',
  children,
  loggedInPreview,
}: LoginConditionWrapperProps) {
  const { user } = useUser();
  const inPlasmicEditor = Boolean(useContext(PlasmicCanvasContext));

  const loggedIn = inPlasmicEditor ? loggedInPreview : Boolean(user);

  const matchesCondition =
    (requiredCondition === 'loggedin' && loggedIn)
    || (requiredCondition === 'loggedout' && !loggedIn);

  if (matchesCondition) return children;
  return null;
}
